function isTooltipAlignment(alignment) {
    return [
        "bottom-center",
        "bottom-left",
        "bottom-right",
        "top-center",
        "top-left",
        "top-right"
    ].includes(alignment);
}
function getPlacement(alignment) {
    return alignment.replace("-left", "-start").replace("-right", "-end").replace("-center", "");
}
// Converter for the storybook from Placement to TooltipAlignment
function getTooltipAlignment(alignment) {
    if (alignment.startsWith("left") || alignment.startsWith("right")) {
        return "bottom-left";
    }
    if (alignment === "top" || alignment === "bottom") {
        return "".concat(alignment, "-center");
    }
    return alignment.replace("-start", "-left").replace("-end", "-right");
}
var Side;
(function(Side) {
    Side["Top"] = "top";
    Side["Bottom"] = "bottom";
    Side["Left"] = "left";
    Side["Right"] = "right";
})(Side || (Side = {}));
function getOppositeSide(side) {
    switch(side){
        case Side.Right:
            return Side.Left;
        case Side.Left:
            return Side.Right;
        case Side.Top:
            return Side.Bottom;
        case Side.Bottom:
        default:
            return Side.Top;
    }
}

export { Side, getOppositeSide, getPlacement, getTooltipAlignment, isTooltipAlignment };
